import { Box, FormHelperText, InputAdornment } from "@mui/material";
import {
  SectionTitle,
  StyledOneChildContainer,
  StyledParentContainer,
  StyledTwoChildContainer,
} from "../../StyledComponents/Container";
import Grid from "@mui/material/Grid2";
import CustomTextFieldComponent from "../../../../shared/CustomTextFeild";
import ContainedButton from "../../../../shared/Button/CustomContainedButton";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OutlinedButton from "../../../../shared/Button/customOutlinedButton";
import CancelPopUp from "../../../PopUp/PopUp";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import CustomTextField from "../../../../shared/CustomTextFeild"
import environment from "../../../../environments/environment"
import { useSelector } from "react-redux";
import * as constants from "../../../../constants";
import { RootState } from "../../../../store/store";
import { getClientDetailsByClientName } from "../../Utils/ClientSettingsTable";

const NewCreditLine = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  const userInfo = useSelector((state: RootState) => state.auth);
  const ClientDetails = getClientDetailsByClientName(userInfo?.clientVo?.name);

  useEffect(() => {
    if (location.state) {
      setFormData(location.state);
    }
  }, []);

  const [openPopUp, setOpenPopUp] = useState(false);

  const [formData, setFormData] = useState({
    sourceOfFund: userInfo?.clientVo?.name,
    name: "",
    projectNumber: "",
    projectTerm: "",
    amount: "",
    interestRate: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    projectNumber: "",
    projectTerm: "",
    amount: "",
    interestRate: "",
  });

  const handleCancel = () => {
    setOpenPopUp(true);
  };

  const handlePopUpClose = () => {
    setOpenPopUp(false);
  };

  const handleConfirm = () => {
    navigate("/creditLineSummaryListing");
  };

  const validateForm = () => {
    const newErrors = { ...errors };

    // Validate required fields
    newErrors.name = formData.name ? "" : translate("nameIsRequired");
    newErrors.projectNumber = formData.projectNumber || ClientDetails?.newCreditLineProjectNumber === constants.IS_ACTIVE_NO
      ? ""
      : translate("projectNumberIsRequired");
    newErrors.projectTerm = formData.projectTerm
      ? ""
      : translate("projectTermIsRequired");
    newErrors.amount = formData.amount ? "" : translate("amountIsRequired");
    newErrors.interestRate = formData.interestRate || (ClientDetails?.newCreditLineProjectNumber === constants.IS_ACTIVE_NO && formData.interestRate !== undefined &&
      formData.interestRate !== null &&
      formData.interestRate !== "")
      ? ""
      : translate("interestRate(APR)IsRequired");

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      navigate("/creditLineReviewAndSubmit", { state: formData });
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "name") {
      const raw = e.target.value || "";
      const trimmedValue = raw.replace(/^\s+/, "");
      setErrors((prev) => ({
        ...prev,
        name: trimmedValue ? "" : translate("nameIsRequired"),
      }));
    }

    if (name === "projectNumber") {
      const raw = e.target.value || "";
      const trimmedValue = raw.replace(/^\s+/, "");
      setErrors((prev) => ({
        ...prev,
        projectNumber: trimmedValue ? "" : translate("projectNumberIsRequired"),
      }));
    }

    if (name === "projectTerm") {
      const raw = e.target.value || "";
      const trimmedValue = raw.replace(/^\s+/, "");
      if (trimmedValue && !Number.isInteger(Number(trimmedValue))) {
        setErrors((prev) => ({
          ...prev,
          projectTerm: translate("projectTermMustBeAnInteger"),
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          projectTerm: trimmedValue ? "" : translate("projectTermIsRequired"),
        }));
      }
    }

    if (name === "amount") {
      const regex = /^\d+(\.\d{0,2})?$/;

      if (value && !regex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          amount: translate("amountIslimitedTo2DecimalPlaces"),
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          amount: value ? "" : translate("amountIsRequired"),
        }));
      }
    }

    if (name === "interestRate") {
      const regex = /^\d+(\.\d{0,2})?$/;
      if (value && !regex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          interestRate: translate("interestRateIslimitedTo2DecimalPlaces"),
        }));
      }
      else {
        setErrors((prev) => ({
          ...prev,
          interestRate: value === ""
            ? translate("interestRate(APR)IsRequired")
            : "",
        }));
      }
    }

    if (name === "name" || name === "description" || name === "projectNumber" || name === "projectTerm") {
      const raw = e.target.value || "";
      const trimmedValue = raw.replace(/^\s+/, "");
      setFormData((prev) => ({
        ...prev,
        [name]: trimmedValue,
      }));
      return;
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  return (
    <StyledParentContainer>
      <StyledOneChildContainer>
        <StyledTwoChildContainer sx={{ border: "none" }}>
          <SectionTitle>{translate("newCreditLine")}</SectionTitle>
          <StyledTwoChildContainer>
            <Box sx={{ width: "100%", padding: "40px" }}>
              <Grid container direction={"column"}>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("sourceOfFund")}
                    value={formData.sourceOfFund}
                    readOnly={true}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <>
                    <CustomTextFieldComponent
                      labelText={translate("name")}
                      placeholder={translate("enterName")}
                      required
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      error={!!errors.name}
                      inputProps={{
                        maxLength: 100,
                      }}
                    />
                    {errors.name && (
                      <FormHelperText sx={{ mt: -1.5 }} error>
                        {errors.name}
                      </FormHelperText>
                    )}
                  </>
                </Grid>
                {ClientDetails?.newCreditLineProjectNumber === constants.IS_ACTIVE_YES && (<Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <>
                    <CustomTextFieldComponent
                      labelText={translate("projectNumber")}
                      placeholder={translate("projectNumber")}
                      required
                      name="projectNumber"
                      value={formData.projectNumber}
                      onChange={handleChange}
                      error={!!errors.projectNumber}
                      inputProps={{
                        maxLength: 45,
                      }}
                    />
                    {errors.projectNumber && (
                      <FormHelperText sx={{ mt: -1.5 }} error>
                        {errors.projectNumber}
                      </FormHelperText>
                    )}
                  </>
                </Grid>)}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <>
                    <CustomTextFieldComponent
                      labelText={translate("projectTerm")}
                      placeholder={translate("projectTerm")}
                      required
                      name="projectTerm"
                      value={formData.projectTerm}
                      onChange={handleChange}
                      error={!!errors.projectTerm}
                      inputProps={{
                        maxLength: 5,
                        pattern: "[0-9]*",
                        inputMode: "numeric",
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {translate("month")}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {errors.projectTerm && (
                      <FormHelperText sx={{ mt: -1.5 }} error>
                        {errors.projectTerm}
                      </FormHelperText>
                    )}
                  </>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <>
                    <NumericFormat
                      customInput={CustomTextField}
                      id="amount"
                      thousandSeparator
                      decimalScale={2}
                      required
                      labelText={translate("amount")}
                      placeholder={translate("amount")}
                      allowNegative={false}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        return (
                          floatValue === undefined ||
                          floatValue <= constants.MAX_AMOUNT_ALLOWED
                        );
                      }}
                      onValueChange={(values) => {
                        const { floatValue } = values;
                        handleChange({
                          target: {
                            name: "amount",
                            value: floatValue,
                          },
                        });
                      }}
                      value={formData.amount}
                      error={!!errors.amount}
                    />
                    {errors.amount && (
                      <FormHelperText sx={{ mt: -1.5 }} error>
                        {errors.amount}
                      </FormHelperText>
                    )}
                  </>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <>
                    <NumericFormat
                      customInput={CustomTextField}
                      id="interest-rate"
                      required
                      labelText={translate("interestRate(APR)")}
                      placeholder={translate("interest")}
                      name="interestRate"
                      value={formData.interestRate}
                      allowNegative={false}
                      suffix="%"
                      decimalScale={2}
                      isAllowed={(values) => {
                        const { floatValue } = values;
                        return floatValue === undefined || floatValue <= constants.MAX_PERCENTAGE_ALLOWED;
                      }}
                      onValueChange={(values) => {
                        const { floatValue } = values;
                        handleChange({
                          target: {
                            name: "interestRate",
                            value: floatValue,
                          },
                        });
                      }}
                      error={!!errors.interestRate}
                    />
                    {errors.interestRate && (
                      <FormHelperText sx={{ mt: -1.5 }} error>
                        {errors.interestRate}
                      </FormHelperText>
                    )}
                  </>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextFieldComponent
                    labelText={translate("enterDescription")}
                    placeholder={translate("enterDescription")}
                    name="description"
                    multiline
                    rows={4}
                    value={formData.description}
                    onChange={handleChange}
                    inputProps={{
                      maxLength: 250,
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </StyledTwoChildContainer>
          <div className="right-fields" style={{ marginTop: "10px" }}>
            <ContainedButton sx={{ mr: 2 }} onClick={handleSubmit}>
              {translate("continue")}
            </ContainedButton>
            <OutlinedButton onClick={handleCancel}>
              {translate("cancel")}
            </OutlinedButton>
          </div>
          <CancelPopUp
            open={openPopUp}
            popupTitle={translate("confirmCancel")}
            handleClose={handlePopUpClose}
            saveChanges={() => handleConfirm()}
            message={translate("doYouWantToCancelChanges?")}
          />
        </StyledTwoChildContainer>
      </StyledOneChildContainer>
    </StyledParentContainer>
  );
};

export default NewCreditLine;
